import http from "./http-commons";

class AlumnosService {
    async EsAlumno() {        
        try {           
          const result = await http.get("/api/v3/alumno", {headers: {'Authorization': `Token ${sessionStorage.getItem("token")}`}});
          return result;
        } catch (error) {
          console.log("error" + error);
          return error;
        }
      } ;  

    async ActualizarNorte(datos_alumno, id){
      try {
        const result = await http.post(
          "/api/v2/alumnos_plataforma/",
          datos_alumno,
          {
            headers: {
              Authorization: `Token ${sessionStorage.getItem("token")}`,
            },
          },
        );
        return result;
      } catch (error) {
        console.log("error" + error.response.data);
        return error;
      }
    }  
      
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new AlumnosService();
